var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfessor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399,390.9a30.53,30.53,0,0,0-13.08-4.49c-2.13-.22-4.46-.16-6.18,1.13a1.29,1.29,0,0,0-.64,1.13,1.36,1.36,0,0,0,.61.77A18.69,18.69,0,0,0,399,390.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.66,390.54a64.21,64.21,0,0,1-8.44-7.43,21.26,21.26,0,0,1-5.29-9.79,4,4,0,0,1,.41-3.28c6.73,5.26,12,12.06,13.32,20.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.93,390.85a30.56,30.56,0,0,1,.15-11.08,15,15,0,0,1,5.91-9.15c1.16,2.72.66,5.85-.16,8.69A42.21,42.21,0,0,1,399,391.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,402.68A19.25,19.25,0,0,0,395,408a19.92,19.92,0,0,0-6,10.3c3.93-.25,7.27-3,9.68-6.12s4.09-6.52,6.75-9.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,404.57a25.85,25.85,0,0,1,3-24.46c2.28,8.12,1.45,17.28-3,24.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.67,415a18.66,18.66,0,0,0-17.87,10.29c-.22.44-.42,1-.12,1.4a1.36,1.36,0,0,0,1.18.35c3.53-.23,6.65-2.35,9.22-4.76s4.83-5.21,7.67-7.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.4,414.38a33.25,33.25,0,0,1-.34-18.6c.66-2.39,1.76-4.91,4-6a.61.61,0,0,1,1,.33,11.22,11.22,0,0,1,.94,5.34,33,33,0,0,1-.84,5.4c-.69,3.3-1.06,6.85-2.88,9.7a21.69,21.69,0,0,0-1.15,2.13c-.34.72-.34,1-.66,1.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.47,417.82c-1.71-6.5.11-14.39,4.2-19.72.31-.39.7-.81,1.2-.77.75.07.95,1.08.91,1.84a35.59,35.59,0,0,1-6.31,18.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.55,419.24a28.66,28.66,0,0,0,23.54-4.79,19.1,19.1,0,0,0-12.74-1.56c-4.26,1-8.15,2.88-10.8,6.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.31,414.91c4.42-7.21,12.9-11.92,21.35-12.35-1,3.44-3.79,6.11-7,7.72a38.62,38.62,0,0,1-10.25,3c-1.37.27-3.24.56-4.12,1.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.91,393.9a61.83,61.83,0,0,0,2.73-12.51A20.83,20.83,0,0,0,439.15,369c-4.13,8-4.55,17.34-.36,25.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.83,386.87c4.83-8.79,14.69-15.8,24.67-16.79-3.85,9.59-14.35,17-24.67,16.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.78,388.59c7.21,1.1,13.35,5.7,20.09,8.49a9,9,0,0,0,4.54.87,3.56,3.56,0,0,0,2.23-6.29,9.94,9.94,0,0,0-3.3-2c-7.34-3.05-15.21-3.13-22.94-1.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.61,393.65c1.64.46,2.19,1.31,3.49,2.41a37.58,37.58,0,0,0,15.23,7.82c.58.15,1.34.2,1.63-.32s-.07-1-.39-1.43a21.05,21.05,0,0,0-9.2-6.24c-3.52-1.31-6.56-2.89-10.76-2.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.91,363.11a28.82,28.82,0,0,0,22.1,7.52,1.53,1.53,0,0,0,1-.36c.56-.61-.11-1.54-.76-2-6.49-5.06-14.37-7.16-22.34-5.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.49,361.07a30.79,30.79,0,0,1,27.57-4.55,21.93,21.93,0,0,1-13.14,5.77,41.82,41.82,0,0,1-14.43-1.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.27,347c-.64-6.49-.23-11.61-.68-18.12,0-.52-.14-1.15-.63-1.34-.68-.26-1.24.57-1.47,1.27a20.76,20.76,0,0,0,2.77,18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.8,347.75a38.16,38.16,0,0,0,10.75-10.44c2.12-2.9,3.91-6.38,3.42-9.94a10.27,10.27,0,0,0-7.75,3.85,21.7,21.7,0,0,0-4,7.94c-.86,2.86-1.46,5.79-2.47,8.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.36,344.82a86.6,86.6,0,0,0,26.43-15.59c-3.15-1.27-6.77-.51-9.93.77a31.3,31.3,0,0,0-16.64,14.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.77,351.3a53.87,53.87,0,0,0,14.68.07c4.76-.79,9.26-2.68,13.7-4.55a1.66,1.66,0,0,0,.94-.71,1.08,1.08,0,0,0-.34-1.17,2.87,2.87,0,0,0-1.17-.55c-4.83-1.35-10.05-.72-14.81.89a69,69,0,0,0-13,6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.9,363.33c-3.33-6.72-3.11-14.56-.23-21.49,2,3.09,2.27,7,1.9,10.69S419.08,360,419,363.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6,356.62a30,30,0,0,0-22.27,9.49,20.82,20.82,0,0,0,12.19-2.26,61.78,61.78,0,0,0,10.46-7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.66,353.63c-4.07-.33-8-.83-11.89.37a14.31,14.31,0,0,0-9.07,7.68,21.45,21.45,0,0,0,11.15-2.1,63.78,63.78,0,0,0,9.81-5.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.9,353.77c-3.66-2.4-7.42-4.84-11.68-5.83s-9.19-.26-12.16,2.95c3.44,2,7.63,2.26,11.63,2.26s8.9,0,12.67,1.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.92,354c-6.25-6.14-8.63-17.17-6.11-25.57A38.94,38.94,0,0,1,409.92,354",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.12,336.56c1.18-2.74,2-5.62,3.07-8.41a24.27,24.27,0,0,1,4.37-7.76,11.56,11.56,0,0,1,7.75-4,31.19,31.19,0,0,1-15,20.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,340.19c-1.95-2.69-4.21-6.34-6.86-8.34s-6.09-3.22-9.32-2.45A21.73,21.73,0,0,0,424,340.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.63,336.78a46.4,46.4,0,0,1-3.09-10,15.62,15.62,0,0,1,1.57-10.16c3.43,6.49,4.54,13.46,1.7,20.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.15,316.63c2-6.43,7.84-11.17,14.2-13.34a5.22,5.22,0,0,1,2.49-.38,2.15,2.15,0,0,1,1.83,1.53c.23,1.1-.67,2.08-1.52,2.81a48.32,48.32,0,0,1-17,9.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.22,311.37c.25-4.15.51-8.36,1.86-12.29s3.95-7.62,7.73-9.34c.64,4.19-1.21,8.36-3.43,12s-4.92,7-6.26,11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.12,314.22c-1.61-4.68-1.77-10.64-4.58-14.73-2-2.85-5.11-4.8-6.8-7.82a11.89,11.89,0,0,0,.4,8.88,25.51,25.51,0,0,0,5.19,7.44c2.08,2.22,3.86,3.89,5.79,6.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.15,452.31c-.12,0-.23-31.28-.24-69.86s.08-69.86.21-69.86.23,31.27.24,69.86S427.28,452.31,427.15,452.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.49,358.61a6.52,6.52,0,0,1-1.18.44l-3.24,1.1c-2.73.93-6.47,2.27-10.54,3.94s-7.83,3.13-10,5a7.19,7.19,0,0,0-2,2.65c-.31.74-.37,1.19-.41,1.18s0-.12,0-.33a5.2,5.2,0,0,1,.23-.91,7.16,7.16,0,0,1,2-2.83,17.28,17.28,0,0,1,4.34-2.7c1.73-.81,3.65-1.65,5.7-2.49,4.08-1.67,7.85-3,10.61-3.83,1.38-.43,2.51-.75,3.29-.95A6.5,6.5,0,0,1,454.49,358.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.45,336.6s-.11.14-.33.36l-1,.94-3.74,3.4-12.48,11.11c-4.86,4.33-9.07,8.47-12,11.59-1.46,1.56-2.61,2.85-3.39,3.75l-.91,1c-.21.24-.32.35-.34.34a2.27,2.27,0,0,1,.27-.4c.19-.25.47-.62.84-1.09.75-.93,1.86-2.26,3.3-3.85a156.75,156.75,0,0,1,11.92-11.71c4.89-4.32,9.33-8.21,12.56-11l3.85-3.29c.42-.36.77-.65,1.06-.88A2,2,0,0,1,463.45,336.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.64,356.81c-.13-.05.89-2.4,1.9-5.37S444,346,444.17,346a18.26,18.26,0,0,1-1.2,5.6,33.56,33.56,0,0,1-1.52,3.76A5.86,5.86,0,0,1,440.64,356.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.18,375.75a6.48,6.48,0,0,1-.75-.87l-1.92-2.47c-1.62-2.09-3.85-5-6.35-8.12s-4.8-6-6.47-8l-2-2.44a5.72,5.72,0,0,1-.68-.92,6,6,0,0,1,.81.81c.5.54,1.21,1.34,2.08,2.34,1.73,2,4.07,4.79,6.57,7.95s4.7,6.07,6.25,8.21c.78,1.07,1.4,1.94,1.81,2.55A5.58,5.58,0,0,1,427.18,375.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.19,368.05a10.86,10.86,0,0,1-2.51-4.7,13.29,13.29,0,0,1-.57-4.74l.2,0c-.09.36-.16.55-.19.55s0-.21,0-.58h.2a21.32,21.32,0,0,0,.8,4.61A34,34,0,0,0,421.19,368.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.45,358.32a7.8,7.8,0,0,0-1.75-1,11.9,11.9,0,0,0-4.87-.39,31.17,31.17,0,0,0-4.9.79,15.81,15.81,0,0,1-2,.49,6.84,6.84,0,0,1,1.93-.79,22.47,22.47,0,0,1,5-.94,10.65,10.65,0,0,1,5,.54A3.16,3.16,0,0,1,413.45,358.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.61,356c0,.07-1-.41-2.68-1a27,27,0,0,0-13.54-1c-1.73.31-2.78.63-2.8.56a2.29,2.29,0,0,1,.71-.3,14.78,14.78,0,0,1,2-.57,23.84,23.84,0,0,1,13.71,1,18.4,18.4,0,0,1,1.92.87C411.39,355.79,411.63,355.93,411.61,356Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.12,346a54.57,54.57,0,0,1-2-6.8,56,56,0,0,1-1.52-6.91,54.57,54.57,0,0,1,2,6.8A56,56,0,0,1,427.12,346Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24,346a31.27,31.27,0,0,0-2.17-4.07,18.49,18.49,0,0,0-3.19-3.3,3.1,3.1,0,0,1,1.23.64,9.73,9.73,0,0,1,2.33,2.4A9,9,0,0,1,427.24,346Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.15,435.64s-.14-.76-.49-2.08a30,30,0,0,0-2.09-5.42,75.12,75.12,0,0,0-11.09-15.63c-2.48-2.82-4.88-5.49-6.92-8.05a57.25,57.25,0,0,1-4.95-7.13,33.06,33.06,0,0,1-2.49-5.3c-.23-.65-.4-1.16-.49-1.51a2.24,2.24,0,0,1-.13-.54s.27.72.78,2a38.94,38.94,0,0,0,2.61,5.2,59.48,59.48,0,0,0,5,7c2.05,2.53,4.46,5.18,6.94,8a71.13,71.13,0,0,1,11,15.78,27.6,27.6,0,0,1,2,5.51c.14.68.24,1.21.28,1.57A2.35,2.35,0,0,1,427.15,435.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.85,407.74a11.79,11.79,0,0,1-1.29.72,29.4,29.4,0,0,0-3.36,2.22,39.27,39.27,0,0,0-4.41,4c-1.55,1.64-3.14,3.54-4.77,5.57-3.25,4.08-6.3,7.7-8.12,10.58-.92,1.43-1.6,2.64-2,3.48a11.58,11.58,0,0,1-.71,1.31,1.46,1.46,0,0,1,.12-.37c.1-.23.23-.58.44-1a31.67,31.67,0,0,1,1.92-3.57,117.33,117.33,0,0,1,8-10.69c1.63-2,3.24-3.94,4.82-5.57a35.63,35.63,0,0,1,4.52-4,22.48,22.48,0,0,1,3.47-2.12,11,11,0,0,1,1-.45C451.72,407.76,451.85,407.72,451.85,407.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.34,416.79a20.28,20.28,0,0,1-2.74.39,36.15,36.15,0,0,0-6.49,1.28,19.52,19.52,0,0,0-5.81,3.05c-1.34,1-2,1.89-2,1.84s.11-.25.4-.63a10.4,10.4,0,0,1,1.43-1.46A17.66,17.66,0,0,1,443,418a29.24,29.24,0,0,1,6.6-1.16A14.36,14.36,0,0,1,452.34,416.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.06,422.36c-.14-.08,1.1-2,2.05-4.5s1.11-4.8,1.27-4.77a4.25,4.25,0,0,1,0,1.47,16.22,16.22,0,0,1-.8,3.45,17,17,0,0,1-1.59,3.18C436.46,422,436.12,422.39,436.06,422.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.85,383.44a2.16,2.16,0,0,1-.44.23l-1.28.58c-.57.25-1.25.55-2,1s-1.67.81-2.61,1.37l-1.5.85c-.51.3-1,.65-1.57,1-1.1.67-2.2,1.49-3.38,2.33a58.63,58.63,0,0,0-13,13.47c-.79,1.2-1.58,2.33-2.21,3.46-.32.55-.66,1.08-.94,1.6l-.79,1.53c-.53.95-.91,1.87-1.29,2.66s-.66,1.47-.88,2-.4,1-.54,1.31-.2.45-.22.44a2.53,2.53,0,0,1,.13-.47c.13-.36.28-.8.47-1.34a21,21,0,0,1,.81-2.09c.35-.8.72-1.73,1.23-2.7l.78-1.54c.27-.54.6-1.07.92-1.63.62-1.14,1.4-2.29,2.19-3.51a55.8,55.8,0,0,1,13.11-13.56c1.19-.84,2.31-1.66,3.43-2.31.55-.34,1.07-.69,1.6-1l1.51-.83c1-.55,1.87-.94,2.66-1.32s1.48-.67,2.06-.89l1.32-.5A1.46,1.46,0,0,1,459.85,383.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.3,396.53a3.2,3.2,0,0,1,1.08-1.6,6.81,6.81,0,0,1,4.33-1.66,11.88,11.88,0,0,1,4.56.89A6.86,6.86,0,0,1,452,395a10.2,10.2,0,0,1-1.83-.54,14,14,0,0,0-4.44-.74,7,7,0,0,0-4.13,1.46A13.56,13.56,0,0,0,440.3,396.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.38,399.55a16.12,16.12,0,0,0,1.23-4,15.81,15.81,0,0,0-.28-4.18,2.65,2.65,0,0,1,.51,1.17,8.21,8.21,0,0,1-.7,6C437.76,399.22,437.42,399.58,437.38,399.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.55,440.12c.67,11.95,4.27,24.11,9.81,36.4h24.1c5.28-12.17,8.64-24.31,9.23-36.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.79,459.46c0,.13-7.94.23-17.72.23s-17.72-.1-17.72-.23,7.93-.23,17.72-.23S444.79,459.34,444.79,459.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.25,463.79c0,.13-7.44.23-16.61.23s-16.61-.1-16.61-.23,7.43-.22,16.61-.22S444.25,463.67,444.25,463.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.75,448a67.08,67.08,0,0,1,0,11.1,70.12,70.12,0,0,1,0-11.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.66,448a71.87,71.87,0,0,1,0,11.49,75.12,75.12,0,0,1,0-11.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.78,447.87a74.77,74.77,0,0,1,0,11.72,78.15,78.15,0,0,1,0-11.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.93,448c0,.12-9.31.22-20.78.22s-20.78-.1-20.78-.22,9.3-.23,20.78-.23S447.93,447.84,447.93,448Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.42,466.47c-1.69-1.45-5.48-6.06-2.56-11.43,1.07-2,3.34-2.94,5.4-3.8a22.11,22.11,0,0,0,5.93-3.07c3.21-2.73,4.09-7.27,6.22-10.92,2.45-4.18,7-7.31,11.84-7.09,5.53.25,10.14,4.76,12.23,9.91s2.16,10.86,2.2,16.41c0,3.08-.11,6.54-2.37,8.61-2.08,1.92-5.21,1.94-8,1.85L42.09,466",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.18,383.43H19.77l14.3,85.3a9.54,9.54,0,0,0,6.78,7.6l.28.08c.24.06.46.14.71.18a9.45,9.45,0,0,0,1.61.18v.09l.39-.07h35.4a10.12,10.12,0,0,0,10-8.53l6.89-58.77.32-2.34h0l2.73-23.27Zm-15,54.42H76.05l.82-24.76h9.44Zm2.91-24.76h7.8L92,437.85H85Zm-23.29,52.2-.49-21.51H75.06l-.71,21.51ZM51.13,443.78H62.54L63,465.29H52.81ZM52,465.29H42.45c-.9-5.81-2.09-13.35-3.37-21.51H50.34Zm-1.35-27.44-1.92-24.76H61.83l.57,24.76Zm12.52,0-.57-24.76H76.08l-.82,24.76Zm-.71-30.7L62,384.23H77l-.76,22.92Zm-.79,0H48.29l-1.78-22.92H61.17Zm-14.19,0H33.31c-.5-3.16-1-6.16-1.41-8.86-1.48-9.27-2-12.75-2.34-14.06H45.72Zm.46,5.94,1.92,24.76H38.15c-.39-2.52-.79-5.06-1.19-7.6-.92-5.84-1.84-11.69-2.71-17.16ZM37.35,437.85H29.69l-4.15-24.76h7.91C34.66,420.74,36,429.26,37.35,437.85Zm.94,5.93c1.16,7.44,2.31,14.78,3.37,21.51H34.29l-3.6-21.51Zm36.85,21.51.71-21.51h7.84l-1.84,21.51Zm1.93-58.14.76-22.92h11l-2,22.92ZM28.81,384.23c.31,1.65,1.76,10.68,3.7,22.92h-8L20.7,384.23Zm60,81.06H82.65l1.83-21.51h6.83Zm6.82-58.14h-8l2-22.92h8.72Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.71,
    y: 32.79,
    width: 400.79,
    height: 230.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.26,263.62H49V32H451.26ZM50.48,262.11H449.74V33.54H50.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.62,
    y: 39.21,
    width: 385.32,
    height: 215.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.7,255.72H57.87V38.45H444.7ZM59.38,254.21H443.19V40H59.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.09,
    y: 252.52,
    width: 415.82,
    height: 10.34,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.67,263.62H41.33V251.77H458.67ZM42.84,262.11H457.16v-8.83H42.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,79.84c0,.22-13.39.4-29.89.4s-29.89-.18-29.89-.4,13.38-.39,29.89-.39S154,79.63,154,79.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,86.09c0,.22-13.39.39-29.89.39s-29.89-.17-29.89-.39,13.38-.39,29.89-.39S154,85.87,154,86.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.09,68.74c0,.21-4.45.39-10,.39s-10-.18-10-.39,4.46-.4,10-.4S114.09,68.52,114.09,68.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,178.58c0,.14-31.58.26-70.51.26S88,178.72,88,178.58s31.57-.26,70.52-.26S229,178.43,229,178.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.87,239.22c-.14,0-.26-30-.26-67.05s.12-67.07.26-67.07.26,30,.26,67.07S145,239.22,144.87,239.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.49,114.5a8.6,8.6,0,0,1-.63,1.86c-.51,1.19-1.28,2.92-2.34,5.11-2.12,4.4-5.3,10.7-9.34,18.42s-8.92,16.89-14.53,27q-2.1,3.78-4.37,7.7c-.77,1.3-1.53,2.63-2.35,3.95l-1.25,2-.73,1-.37.51-.42.44a18.6,18.6,0,0,1-8.41,5.13,13.45,13.45,0,0,1-5.14.41,12.81,12.81,0,0,1-5-1.68,27.68,27.68,0,0,1-7.32-6.92,83.63,83.63,0,0,1-5.59-7.86,123.32,123.32,0,0,1-8.43-16.1c-2.34-5.29-4.32-10.4-6.15-15.19s-3.47-9.28-4.92-13.39c-2.91-8.22-5-15-6.37-19.65-.66-2.35-1.15-4.18-1.45-5.43A9.18,9.18,0,0,1,98,99.83a8.41,8.41,0,0,1,.69,1.84c.4,1.24,1,3,1.74,5.33,1.52,4.62,3.78,11.29,6.81,19.45,1.52,4.09,3.22,8.54,5.1,13.3s3.9,9.84,6.26,15.07a124.87,124.87,0,0,0,8.4,15.87,83.54,83.54,0,0,0,5.51,7.7,26.33,26.33,0,0,0,6.9,6.55,11.31,11.31,0,0,0,8.9,1.12,17,17,0,0,0,7.72-4.69l.39-.41.32-.44.65-.88,1.23-1.94c.8-1.3,1.57-2.61,2.34-3.9q2.28-3.9,4.41-7.66c5.67-10,10.64-19.12,14.81-26.77s7.49-13.86,9.76-18.17c1.12-2.14,2-3.81,2.6-5A10.42,10.42,0,0,1,193.49,114.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,165.58a7.66,7.66,0,0,1-2.81.26,7.63,7.63,0,0,1-2.8-.26,15.26,15.26,0,0,1,5.61,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,151.15a7.66,7.66,0,0,1-2.81.26,7.63,7.63,0,0,1-2.8-.26,15.26,15.26,0,0,1,5.61,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,136.73a15.26,15.26,0,0,1-5.61,0,14.71,14.71,0,0,1,5.61,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,122.3a15.26,15.26,0,0,1-5.61,0,7.63,7.63,0,0,1,2.8-.26A7.66,7.66,0,0,1,144.49,122.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,216.78a15.26,15.26,0,0,1-5.61,0,7.63,7.63,0,0,1,2.8-.26A7.66,7.66,0,0,1,144.49,216.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,202.35a15.26,15.26,0,0,1-5.61,0,7.63,7.63,0,0,1,2.8-.26A7.66,7.66,0,0,1,144.49,202.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,187.92a15.26,15.26,0,0,1-5.61,0,7.63,7.63,0,0,1,2.8-.26A7.66,7.66,0,0,1,144.49,187.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.78,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.35,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.92,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.49,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.4,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.29,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.11,179.85a15.26,15.26,0,0,1,0,5.61,15.26,15.26,0,0,1,0-5.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.19,110.78a11.41,11.41,0,0,1-1.42-1.88c-.82-1.2-1.93-2.87-3.13-4.73l0,0,.44,0c-1.05,1.94-2,3.68-2.75,4.92a11.1,11.1,0,0,1-1.27,2,9.6,9.6,0,0,1,1-2.14c.64-1.29,1.57-3.06,2.62-5l.21-.39.23.37,0,0c1.2,1.87,2.26,3.57,3,4.82A10.78,10.78,0,0,1,149.19,110.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.3,182.66a10.66,10.66,0,0,1,1.88-1.43c1.2-.82,2.87-1.93,4.73-3.12l.05,0v.45c-1.93-1.06-3.67-2-4.92-2.76a11.22,11.22,0,0,1-2-1.27,10.22,10.22,0,0,1,2.14.95c1.29.64,3.05,1.57,5,2.62l.39.21-.37.24-.05,0c-1.86,1.2-3.56,2.26-4.81,3A10.55,10.55,0,0,1,224.3,182.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.36,149.87s0-.09,0-.24,0-.4,0-.69q0-.91,0-2.64c0-2.32,0-5.69-.05-10,0-8.57-.06-20.79-.1-35.43l.2.2-49,0h0l.23-.23c0,17.93,0,34.73,0,49l-.2-.21,35.44.11,10,0,2.64,0h.68l.24,0h-.88l-2.6,0L384,150l-35.57.11h-.2v-.2c0-14.24,0-31,0-49v-.24h.24l49,0h.2v.2c0,14.7-.08,27-.1,35.56,0,4.26,0,7.62,0,9.93,0,1.12,0,2,0,2.6,0,.28,0,.5,0,.66A1.76,1.76,0,0,1,397.36,149.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.36,149.87s.12-.1.37-.27l1.13-.72,4.33-2.73,15.95-9.93-.09.15c0-12.78,0-29.71-.05-48.24l.23.24h-.14l-48.26-.06.08,0-16.43,9.26-4.5,2.5-1.18.64-.41.21a3.9,3.9,0,0,1,.39-.25l1.15-.69,4.45-2.58L370.74,88l0,0h.05l48.26-.06h.37v.23c0,18.53,0,35.46,0,48.24v.1l-.08.05-16,9.8L398.91,149l-1.15.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23,88.13c.06.11-4.78,3.06-10.82,6.59s-11,6.29-11.05,6.18,4.78-3.06,10.82-6.59S419.16,88,419.23,88.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.71,147.85c.07.12-.4.5-1,.87s-1.22.58-1.28.47.4-.5,1.05-.87S350.65,147.74,350.71,147.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.36,145.19c.06.11-.4.5-1.05.87s-1.21.57-1.27.46.4-.5,1-.87S355.3,145.08,355.36,145.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,142.52c.06.11-.41.5-1.05.87s-1.21.58-1.28.46.41-.5,1.05-.86S359.94,142.41,360,142.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.65,139.85c.07.11-.4.5-1,.87s-1.22.58-1.28.47.4-.5,1.05-.87S364.59,139.74,364.65,139.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3,137.19c.06.11-.4.5-1.05.86s-1.21.58-1.27.47.4-.5,1-.87S369.24,137.07,369.3,137.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.48,132.49c.13,0,.22.6.22,1.34s-.12,1.34-.24,1.34-.23-.6-.23-1.34S370.35,132.49,370.48,132.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.52,127.13c.13,0,.23.61.22,1.35s-.11,1.33-.24,1.33-.23-.6-.22-1.34S370.39,127.13,370.52,127.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.56,121.78c.13,0,.23.6.22,1.34s-.11,1.34-.24,1.34-.23-.61-.22-1.35S370.43,121.78,370.56,121.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.6,116.42c.13,0,.23.6.22,1.34s-.11,1.34-.24,1.34-.23-.6-.22-1.34S370.47,116.42,370.6,116.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,111.06c.13,0,.23.6.23,1.34s-.12,1.34-.25,1.34-.22-.6-.22-1.34S370.52,111.06,370.64,111.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,105.7c.13,0,.22.61.22,1.35s-.12,1.33-.24,1.33-.23-.6-.23-1.34S370.56,105.7,370.69,105.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.73,100.35c.13,0,.23.6.22,1.34s-.11,1.34-.24,1.34-.23-.61-.22-1.35S370.6,100.35,370.73,100.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.77,95c.13,0,.23.6.22,1.34s-.11,1.34-.24,1.34-.23-.6-.22-1.34S370.64,95,370.77,95Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.81,89.63c.13,0,.23.6.23,1.34s-.12,1.34-.25,1.34-.23-.6-.22-1.34S370.68,89.63,370.81,89.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.55,136.37c0-.13.6-.23,1.34-.23s1.34.1,1.34.23-.6.23-1.34.23S416.55,136.5,416.55,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.19,136.37c0-.13.6-.23,1.34-.23s1.34.1,1.34.23-.6.23-1.34.23S411.19,136.5,411.19,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.84,136.37c0-.13.6-.23,1.34-.23s1.33.1,1.33.23-.6.23-1.33.23S405.84,136.5,405.84,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.48,136.37c0-.13.6-.23,1.34-.23s1.34.1,1.34.23-.6.23-1.34.23S400.48,136.5,400.48,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,136.37c0-.13.6-.23,1.34-.23s1.34.1,1.34.23-.6.23-1.34.23S395.12,136.5,395.12,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76,136.37c0-.13.6-.23,1.34-.23s1.34.1,1.34.23-.6.23-1.34.23S389.76,136.5,389.76,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.41,136.37c0-.13.6-.23,1.33-.23s1.34.1,1.34.23-.6.23-1.34.23S384.41,136.5,384.41,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.05,136.37c0-.13.6-.23,1.34-.23s1.34.1,1.34.23-.6.23-1.34.23S379.05,136.5,379.05,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.69,136.37c0-.13.6-.23,1.34-.23s1.34.1,1.34.23-.6.23-1.34.23S373.69,136.5,373.69,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.44,136.37a.26.26,0,0,1,.29-.23.23.23,0,1,1,0,.46A.26.26,0,0,1,370.44,136.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.16,120.06a6.22,6.22,0,0,0,1.22-.06,3.77,3.77,0,0,0,2.54-1.91,5.13,5.13,0,0,0-.14-4.66,1.44,1.44,0,0,0-1-.77,1.66,1.66,0,0,0-1.25.33,5.88,5.88,0,0,0-1.55,2.6,12.09,12.09,0,0,0-.7,3.32h-.45c-.05-3.54-.08-6.64-.08-8.85,0-1,0-1.9,0-2.6a4.32,4.32,0,0,1,.07-.94,4.74,4.74,0,0,1,.09.94c0,.69.07,1.56.12,2.59.07,2.21.16,5.31.23,8.86h-.45a12,12,0,0,1,.71-3.46,10.81,10.81,0,0,1,.67-1.51,3.74,3.74,0,0,1,1.05-1.29,2.11,2.11,0,0,1,1.61-.41,1.87,1.87,0,0,1,1.24,1,5.43,5.43,0,0,1,.06,5,3.92,3.92,0,0,1-2.8,1.93,2.78,2.78,0,0,1-.94,0A.9.9,0,0,1,425.16,120.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.42,82.55s0,.06-.11.17a1.74,1.74,0,0,1-.48.35,2,2,0,0,1-.94.2,1.81,1.81,0,0,1-1.2-.5,3.59,3.59,0,0,1-.81-1.37c-.2-.52-.4-1.1-.57-1.71a19.91,19.91,0,0,1-.68-4.23l.44,0a16.28,16.28,0,0,1-.16,5.58,5.12,5.12,0,0,1-1.74,2.85,2.14,2.14,0,0,1-1.63.36,2,2,0,0,1-1.28-1,5.5,5.5,0,0,1,2.65-7.45,4.78,4.78,0,0,1,.89-.31,1.19,1.19,0,0,1,.33,0s-.43.13-1.14.51a5.48,5.48,0,0,0-2.33,2.35,5.41,5.41,0,0,0-.58,2.2,4.57,4.57,0,0,0,.55,2.51,1.58,1.58,0,0,0,1,.77,1.75,1.75,0,0,0,1.29-.31,4.69,4.69,0,0,0,1.54-2.59,16.1,16.1,0,0,0,.17-5.43l.44,0a19.44,19.44,0,0,0,.6,4.14c.15.61.33,1.18.51,1.7a3.59,3.59,0,0,0,.69,1.29,1.76,1.76,0,0,0,1.9.36A4.19,4.19,0,0,0,401.42,82.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.2,
    y: 321.36,
    width: 7.42,
    height: 155.49,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.4,
    y: 321.36,
    width: 7.42,
    height: 155.49,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.15,
    y: 304.1,
    width: 223.05,
    height: 98.81,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.51,
    y: 299.89,
    width: 311.37,
    height: 16.49,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.13,
    y: 308.13,
    width: 67.59,
    height: 94.78,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.22,315.3c0,.21-69.06.38-154.22.38s-154.24-.17-154.24-.38,69-.38,154.24-.38S359.22,315.09,359.22,315.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.72,
    y: 315.3,
    width: 7.42,
    height: 161.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.76,
    y: 315.3,
    width: 7.42,
    height: 161.56,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.32,433.59l4.48,24s-22.84,12.59-22.45,17.1l46.75-7L312.66,430Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.32,433.59l4.48,24s-22.84,12.59-22.45,17.1l46.75-7L312.66,430Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308,453.35a1.93,1.93,0,0,1,1.65,2,1.87,1.87,0,0,1-2,1.65,2,2,0,0,1-1.73-2.11,1.91,1.91,0,0,1,2.21-1.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.1,467.63l-.69-3.77L272.84,472s-1.94,1.22-1.49,2.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,457.41c0,.23,1.19.16,2.43.73s2,1.43,2.17,1.31-.34-1.39-1.85-2.05S292.92,457.21,293,457.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.41,460.18c0,.23,1,.47,1.94,1.32s1.3,1.83,1.53,1.79.17-1.36-1-2.39S288.38,460,288.41,460.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.5,466.46c.22,0,.36-1.17-.41-2.33s-1.92-1.5-2-1.3.69.78,1.31,1.74S286.27,466.47,286.5,466.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.59,451.84c.13.2,1.13-.28,2.43-.38s2.37.15,2.46-.07-1-.88-2.53-.73S292.45,451.68,292.59,451.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.59,439.32l.43,24.36s-24.62,8.62-25,13.13l47.27.86.88-38Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,461.9a1.93,1.93,0,0,1,1.3,2.22,1.87,1.87,0,0,1-2.2,1.31,2,2,0,0,1-1.36-2.37,1.93,1.93,0,0,1,2.44-1.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.31,477.67l-.06-3.83-45.3.6s-2.12.88-1.91,2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.26,463.42c0,.23,1.15.36,2.27,1.12s1.71,1.75,1.93,1.66-.11-1.43-1.48-2.33S304.21,463.21,304.26,463.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.26,465.38c-.05.23.94.64,1.7,1.63s1,2,1.21,2,.4-1.31-.58-2.52S299.27,465.16,299.26,465.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.34,471.26c.21.06.55-1.09,0-2.36s-1.64-1.8-1.74-1.61.55.88,1,1.93S296.11,471.24,296.34,471.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.77,457.86c.1.21,1.16-.09,2.46,0s2.32.54,2.44.34-.84-1-2.37-1.15S304.66,457.68,304.77,457.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.93,250.17l-.63,24.1-7.12,74.82s2.27,36.45,3.71,57C335.14,424,331.53,455,331.53,455l-30.08-.79-8.06-103.81-5-64.74-9.89-33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,254.38l-1.8,99.12a41.07,41.07,0,0,0,2.4,14.65l25.85,72,1.27,4.75L309.29,441,296.78,251.92l-33.35,1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8,272.94a2.42,2.42,0,0,0,0,.47c0,.34,0,.79,0,1.38,0,1.24,0,3,0,5.3,0,4.6.13,11.26.35,19.48.48,16.45,1.58,39.17,3.57,64.18s4.23,47.63,5.91,64c.85,8.15,1.54,14.75,2,19.36.24,2.25.44,4,.57,5.26.07.57.13,1,.17,1.36a2.87,2.87,0,0,0,.07.46,2.08,2.08,0,0,0,0-.47c0-.33-.06-.79-.1-1.37-.12-1.24-.27-3-.48-5.27-.44-4.61-1.07-11.22-1.85-19.38-1.57-16.36-3.79-39-5.74-64s-3.15-47.7-3.73-64.14c-.27-8.22-.47-14.88-.53-19.48-.05-2.27-.09-4.05-.12-5.3,0-.58,0-1-.05-1.37A2.84,2.84,0,0,0,288.8,272.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.22,260.18a1.55,1.55,0,1,0,1.59-1.5A1.55,1.55,0,0,0,287.22,260.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.82,271.75a9.86,9.86,0,0,0,2.17-1.93,24.07,24.07,0,0,0,3.94-5.82,23.79,23.79,0,0,0,2.07-6.72,9.51,9.51,0,0,0,.14-2.9c-.09,0-.18,1.1-.53,2.83a28.92,28.92,0,0,1-2.19,6.55,28.46,28.46,0,0,1-3.73,5.8C263.56,270.92,262.75,271.68,262.82,271.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.05,256.35a3.72,3.72,0,0,0,.1,1.11,16.7,16.7,0,0,0,.77,2.93,19.19,19.19,0,0,0,14.67,12.42,17.17,17.17,0,0,0,3,.29,4.08,4.08,0,0,0,1.11-.09c0-.11-1.58-.05-4.05-.59a19.88,19.88,0,0,1-14.37-12.18C315.36,257.9,315.15,256.33,315.05,256.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.43,253.29c.14,0,.1,9.52-.09,21.26s-.46,21.25-.6,21.25-.11-9.52.08-21.26S263.28,253.28,263.43,253.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.16,272a24.47,24.47,0,0,1,.07-3.3c.1-2,.22-4.86.29-8s.07-5.92.07-8a22.28,22.28,0,0,1,.08-3.31,20.81,20.81,0,0,1,.29,3.3c.09,2,.15,4.87.08,8s-.25,5.94-.44,8A17.57,17.57,0,0,1,337.16,272Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,120.25l-2-2.63s-1-2.15-.55-3.12,2-.4,2-.4l7.82,8.81-2.73,2.25-4.23-4.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,154.17l-15.79-12.85s-.92-2.4-2.42-3a5.88,5.88,0,0,1-3-4.29l-2.42-8.36c-.06-.89-2.21-5.65-3-6.1l-2.15-.4s-.71-3.59-2.35-4-6.71-.22-6.71-.22L197,117.31a4.2,4.2,0,0,0,3.37,2.07,21.63,21.63,0,0,0,4.36-.56l1.28,3.9s.37,2.9-.12,4.1a4,4,0,0,1-1.18,1.7,57.77,57.77,0,0,1-3.44-5c-1-1.82-3.81-4.08-4.89-3s1.12,3.26,1.42,5.28l.34,2.6s1.85,3.21,2,3.77,1.47,4,2.87,5.17l6.24,5.35,5.89,7c1.76,2.05,18.21,20.41,18.21,20.41l8.21-11.7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.48,140.55c.18.63,4.86,4.73,4.86,4.73s11.82,9.05,14.44,12.21,13.27,8.86,13.27,8.86l10.2-20.49L283,135.81c3.52-3.53,13.52,3,13.52,3l-29.25,68.51-21.62-8.08-28.26-40.42-4.58-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,117.27l4.16,5.89s26.4,13.32,27.52,15.11-6.94,64.81-6.94,64.81l3.23,38.29-3.85,10.3-74.85,4.2c-1.17-.46-4-3-4.25-7.34-.16-3.34,2.51-6.8,2.49-9-.18-15.52,1.49-51.16,4-64.31,3.35-17.46,11-34.7,11-34.7l6.71-4.7,1.34-7.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340.05,232.29a8,8,0,0,0-3.57-1.17c-13.91-2.42-25.44-12.34-39.09-16a17.36,17.36,0,0,0-8.66-.51c-4.6,1.16-8,5.3-9.5,9.78s-1.88,9.84-1.88,14.44c3.84-.34,7.8-3.56,9.55-7,.71-1.4,1.2-3,2.51-3.92s3-.73,4.58-.54l10.58,1.29a41.13,41.13,0,0,1,7.8,1.47c2.73.89,5.23,2.34,7.87,3.48a36.39,36.39,0,0,0,18.32,2.75,3.23,3.23,0,0,0,2.1-.78C341.52,234.68,341.05,233.07,340.05,232.29Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.78,145.49c-1.31,4-1.61,8.29-1.9,12.51-1,14.12-1.41,27.05-2.38,41.17.18-.39-.18.4,0,0l4.69-.61a269.21,269.21,0,0,1,7.06-63C292.56,137.66,290.1,141.47,288.78,145.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,143.8s-7.23,15.57-9.35,22.16-3.58,32-3.58,32l-1.33,32.62,6.54,8.23,6.34-5.45,7.68-88.83Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.69,233.41c-.14,0,1-19.88,2.62-44.39s3-44.37,3.14-44.37-1,19.89-2.62,44.4S283.83,233.42,283.69,233.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,138.27a22.73,22.73,0,0,1,9.73,13.82c2.57,9.89,11.06,48.43,11.86,54.35s-.6,14-3.17,16.21-18.18,12.12-25.1,12.12S318,230.26,318,230.26L321,214.75,332.69,212l9.09-8.9L331.5,180.55S335.57,140.26,345.49,138.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.72,207.12c-.07.06-.69-.82-2-1.94a14.23,14.23,0,0,0-5.82-3,12.25,12.25,0,0,0-6.52.21c-1.63.48-2.58,1-2.62.91s.2-.19.62-.43a13.16,13.16,0,0,1,1.89-.83,11.76,11.76,0,0,1,6.76-.37,13.24,13.24,0,0,1,5.94,3.27,11.17,11.17,0,0,1,1.36,1.55C358.62,206.86,358.75,207.1,358.72,207.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.62,232.83c-.08-.06.74-1,1.65-2.69a15.72,15.72,0,0,0,.11-14.55c-.88-1.73-1.69-2.66-1.61-2.71s.25.18.6.6a13.34,13.34,0,0,1,1.33,1.94,15,15,0,0,1-.11,14.9,12.07,12.07,0,0,1-1.36,1.91C331.87,232.65,331.64,232.85,331.62,232.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.99 131.84 283.15 139.44 284.94 144.12 291.19 144.86 296.72 136.06 291.37 131.38 288.99 131.84",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.44,195.57c0,.1-.94,0-2.42.1a12.54,12.54,0,0,0-2.54.48,15.2,15.2,0,0,0-2.9,1.25,15.89,15.89,0,0,0-4.34,3.76c-.93,1.15-1.38,2-1.46,1.92a6.89,6.89,0,0,1,1.17-2.15,14.11,14.11,0,0,1,4.37-4,13.47,13.47,0,0,1,3-1.26,11.62,11.62,0,0,1,2.65-.39,8.17,8.17,0,0,1,1.8.11A1.9,1.9,0,0,1,355.44,195.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.79,139.61c0,.09-.94.43-2.36,1.26a16.86,16.86,0,0,0-7.61,9.92c-.44,1.59-.51,2.62-.61,2.61a2.19,2.19,0,0,1,0-.73,10,10,0,0,1,.27-2,15.41,15.41,0,0,1,7.79-10.15,10.66,10.66,0,0,1,1.83-.78A2.31,2.31,0,0,1,342.79,139.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.89,124.3a9.61,9.61,0,0,1-.85,1.32l-2.49,3.48c-2.11,2.93-5.06,7-8.35,11.37l-1.07,1.44-.16.22-.22-.18c-3.92-3.25-7.39-6.17-9.88-8.29L291,131.15a7.53,7.53,0,0,1-1-1,7.16,7.16,0,0,1,1.14.82l3,2.39c2.54,2.05,6.06,4.92,10,8.17l-.38,0,1.07-1.44c3.29-4.42,6.29-8.41,8.48-11.28l2.62-3.38A9,9,0,0,1,316.89,124.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.23,168.86a3.42,3.42,0,0,1,.26.45l.65,1.31,2.3,4.87c1.93,4.12,4.55,9.83,7.42,16.15,1.87,4.15,3.63,8,5.12,11.35l.07.14-.11.11c-2.61,2.79-5,4.87-6.6,6.41l-1.85,1.79a4.41,4.41,0,0,1-.68.62,5.78,5.78,0,0,1,.57-.71c.4-.45,1-1.09,1.77-1.89,1.54-1.6,3.91-3.73,6.46-6.53l0,.25-5.18-11.32c-2.87-6.32-5.45-12.06-7.28-16.22L327,170.7l-.56-1.35A1.72,1.72,0,0,1,326.23,168.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.57,221.92a2.43,2.43,0,0,1-.41.52,3.7,3.7,0,0,1-.56.58c-.24.21-.5.48-.83.72a46.12,46.12,0,0,1-5.87,3.84c-2.57,1.47-5.69,3.1-9.21,4.8A23.46,23.46,0,0,1,335.3,235a16.53,16.53,0,0,1-5.19-1.21h.05l-12.38-3.39-.2-.05,0-.2c.86-4.25,1.58-7.8,2.1-10.35.26-1.2.46-2.16.62-2.88a7.21,7.21,0,0,1,.26-1,6,6,0,0,1-.13,1c-.13.73-.3,1.7-.5,2.91-.48,2.56-1.14,6.11-1.92,10.38l-.16-.25,12.4,3.32h0a16,16,0,0,0,5,1.16A23.28,23.28,0,0,0,347.48,232c3.53-1.67,6.66-3.27,9.24-4.7a52.26,52.26,0,0,0,5.92-3.67A22,22,0,0,0,364.57,221.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.88,152.48a1.38,1.38,0,0,1-.06.47c-.07.36-.16.79-.26,1.3-.26,1.22-.6,2.84-1,4.8-.84,4-2,9.65-2.89,15.89s-1.53,11.93-1.84,16.05c-.16,2.06-.28,3.73-.34,4.88,0,.53-.07,1-.1,1.33a1.62,1.62,0,0,1-.07.47,1.43,1.43,0,0,1,0-.47v-1.33c0-1.16.06-2.84.18-4.91.22-4.13.74-9.84,1.69-16.1S267.25,163,268.18,159c.47-2,.88-3.64,1.18-4.76l.36-1.29A1.71,1.71,0,0,1,269.88,152.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.94,130.18a15.66,15.66,0,0,1-1.48,2.38c-1,1.44-2.33,3.4-3.86,5.55l-2.37,3.27-.63.86.21-1c.31-1.61.59-3,.8-3.91a6,6,0,0,1,.41-1.48,5.65,5.65,0,0,1-.13,1.53c-.13,1-.35,2.33-.62,3.94l-.42-.18c.71-1,1.5-2.12,2.32-3.3,1.54-2.14,2.95-4.07,4-5.45A14.54,14.54,0,0,1,289.94,130.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,133.41c.07.11-2.19,1.84-4.59,4.41s-4.53,4.54-4.64,4.41a7.75,7.75,0,0,1,1.19-1.45c.78-.85,1.84-2,3.07-3.32a29,29,0,0,1,3.37-3.05A5.46,5.46,0,0,1,293.59,133.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,183.77a11.23,11.23,0,0,1-.16-2.61,46,46,0,0,1,.47-6.3,46.49,46.49,0,0,1,1.31-6.17,10.21,10.21,0,0,1,.89-2.47,18.22,18.22,0,0,1-.53,2.56c-.36,1.56-.81,3.73-1.16,6.16s-.52,4.63-.61,6.23A15,15,0,0,1,254.43,183.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,180a32.24,32.24,0,0,1-.33-6.84,31.73,31.73,0,0,1,.61-6.82c.15,0,0,3.06-.09,6.83S257.19,180,257,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.34,146.73a15.28,15.28,0,0,1-1.94,1.89c-1.38,1.24-3,2.72-4.85,4.37s-3.66,3.19-5,4.25a12.42,12.42,0,0,1-2.18,1.61,15.23,15.23,0,0,1,1.94-1.89l4.85-4.36c1.91-1.7,3.66-3.2,5-4.26A13.39,13.39,0,0,1,231.34,146.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.82,198c-.59.35-4.91,2.77-5.12,5h0l43.88,7.69,41.34-14.06-8.32-7s-35.26,2.94-34.66,12.78c0,0-1.4-3.16-7.84-4.45S256.82,198,256.82,198Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,202.92l.1.6,6.42,15.56H311l21.65-7.1,5.67-16.38L300,203.08s-1,4.78-5.36,5c-3.76.22-4.76-4.45-4.76-4.45Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,202.92h.67l2,0,7.79.1,28.51.43H290l0,.16a7.18,7.18,0,0,0,1.54,3,3.71,3.71,0,0,0,3.12,1.25,5,5,0,0,0,3.24-1.52,7.4,7.4,0,0,0,1.79-3.33l0-.15.14,0,38.4-7.52.44-.08-.14.42c-.95,2.73-1.95,5.62-3,8.55-.92,2.64-1.82,5.25-2.72,7.83l0,.13-.12,0-21.65,7.08,0,0h0l-53.67-.11h-.1l0-.09c-3.74-9.16-6-14.69-6.29-15.6h0c-.08-.56-.08-.61-.08-.61s0,.07.12.6h0c.42.87,2.73,6.37,6.54,15.5l-.13-.09,53.67-.1H311l21.64-7.11-.16.16c.89-2.58,1.8-5.19,2.71-7.83l3-8.55.29.34L300,203.31l.18-.18a7.8,7.8,0,0,1-1.92,3.55,5.45,5.45,0,0,1-3.53,1.64,4,4,0,0,1-1.92-.29,4.41,4.41,0,0,1-1.55-1.11,7.58,7.58,0,0,1-1.62-3.21l.2.16-28.37-.66-7.84-.2-2.06-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.93,215.12a26.9,26.9,0,0,1-1.15-5.89,27.17,27.17,0,0,1-.33-6,47.46,47.46,0,0,1,.85,5.93A48.67,48.67,0,0,1,290.93,215.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.33,215.26c-.15,0-.15-2.7-.3-6a59.38,59.38,0,0,1-.22-6,38,38,0,0,1,.52,12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.63,217.47a9.08,9.08,0,0,1-3-2.62,1.75,1.75,0,0,1,.74-2.5,2.47,2.47,0,0,1,1.61.26c1.39.56,2.76,1.18,4.11,1.83-.71-1-1.42-2.37-.67-3.34s2.23-.63,3.35-.19c2.56,1,5.06,2.15,7.68,2.94a17.58,17.58,0,0,0,8.13.73,5.8,5.8,0,0,0,2.85-1.2,15.89,15.89,0,0,0,1.71-2.19,7.88,7.88,0,0,1,4.36-2.81,1.63,1.63,0,0,1,1.32.09c.64.45.46,1.42.33,2.19a7.92,7.92,0,0,0,2.16,6.9l-6.44,1.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M320.79,216.73a6,6,0,0,0-1.36-2.95c-1.08-1.08-1.74-1.36-1.88-2.21s.89-1.64.89-2.53-1.54-1.83-3.42-.89a5.87,5.87,0,0,0-2.72,4.1c-.14.87.66,2.42,0,3.26s-4.11.38-4.11.38L297,215.12s-6.94-6.41-11.25-4.11l2.81,3.42s-5-3-7.17-1.45l-.33.7,12.65,8.58,7.7,2.78,17.89,2.13s3.14-1.77,3.14-4.82A11.12,11.12,0,0,0,321,217",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,221.33a15.88,15.88,0,0,1-3.11-.21,28.3,28.3,0,0,1-3.34-.59,9.12,9.12,0,0,1-1.92-.66,13,13,0,0,1-1.85-1.16,36.42,36.42,0,0,1-5.44-5.2,12.92,12.92,0,0,1-1.86-2.5,30.67,30.67,0,0,1,2.13,2.25,45.26,45.26,0,0,0,5.48,5,14.45,14.45,0,0,0,1.76,1.13,10.72,10.72,0,0,0,1.82.65c1.21.33,2.34.52,3.28.69A22.77,22.77,0,0,1,303.3,221.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.75,144.55a20.92,20.92,0,0,1-6.56-.58,20.92,20.92,0,0,1,6.56.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.43,82.92a3,3,0,1,0-1.69-5.43,3.4,3.4,0,0,0,.14-4.58A6,6,0,0,0,329.34,71a10,10,0,0,0-10.23,9.09l.07-.52c-1.87,2.63-2.83,4.29-2.54,7.5.1,1.13.59,2.48,1.72,2.6a5.39,5.39,0,0,1,1.14,0,1.91,1.91,0,0,1,.79.65c1.57,1.89,3.4,3.78,5.8,4.29s5.36-1.06,5.38-3.51a2.85,2.85,0,0,0,3.9.59A5.59,5.59,0,0,0,337.51,88C337.9,86,337.38,83.45,335.43,82.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,97.33a16,16,0,0,1,.73-3.91,7.85,7.85,0,0,0,.23-3.93A3.24,3.24,0,0,0,316.23,87l-7.4,26.78c3.34-.68,10.68-6.62,10.46-10C319.15,101.55,318,99.51,318,97.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3,117.48l-.23-32.83c.57-12-5.95-22.38-18-22.62l-1.11,0a21.53,21.53,0,0,0-20.69,20.6c-.44,10.43-.79,22-.51,27.53.59,11.54,12.21,12.89,12.21,12.89l0,5.07,4.93,1.79Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,123.09a26.89,26.89,0,0,0,14.89-4.86s-3.24,8.45-14.8,7.85Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.2,91.51a1.64,1.64,0,0,0,1.65,1.6,1.57,1.57,0,0,0,1.64-1.55,1.64,1.64,0,0,0-1.65-1.6A1.57,1.57,0,0,0,276.2,91.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.59,86.69c.21.2,1.43-.77,3.2-.83s3.11.77,3.3.55-.14-.48-.72-.87a4.5,4.5,0,0,0-2.65-.71,4.3,4.3,0,0,0-2.53.93C275.66,86.2,275.49,86.59,275.59,86.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.41,92a1.65,1.65,0,0,0,1.65,1.6A1.57,1.57,0,0,0,295.7,92a1.65,1.65,0,0,0-1.65-1.61A1.57,1.57,0,0,0,292.41,92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.45,86.45c.18.23,1.5-.6,3.27-.47s3,1.1,3.21.9-.08-.49-.61-.94a4.54,4.54,0,0,0-2.56-1,4.41,4.41,0,0,0-2.62.64C293.57,86,293.35,86.35,293.45,86.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,101.3a11.9,11.9,0,0,0-2.9-.41c-.46,0-.89-.11-1-.41a2.32,2.32,0,0,1,.25-1.36c.39-1.11.79-2.27,1.21-3.5,1.67-5,2.86-9.07,2.66-9.14s-1.72,3.92-3.39,8.91c-.4,1.23-.78,2.4-1.15,3.52a2.66,2.66,0,0,0-.17,1.78,1.16,1.16,0,0,0,.77.64,3.27,3.27,0,0,0,.78.08A12,12,0,0,0,287.5,101.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.83,79.92c.2.47,2,.17,4.05.35s3.8.67,4.06.23c.11-.22-.2-.66-.89-1.1a6.82,6.82,0,0,0-3-.93,6.71,6.71,0,0,0-3.14.49C293.12,79.3,292.75,79.69,292.83,79.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.84,82.9c.33.39,1.54-.07,3-.15s2.72.17,3-.27c.12-.21-.09-.6-.65-1a4.34,4.34,0,0,0-4.83.33C275.85,82.29,275.7,82.71,275.84,82.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.77,102.32c-.29,0-.22,1.92-1.82,3.35s-3.65,1.3-3.66,1.57.48.36,1.34.35a4.82,4.82,0,0,0,3.06-1.2,4.18,4.18,0,0,0,1.4-2.81C293.13,102.78,292.9,102.31,292.77,102.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.78,85.89a1.79,1.79,0,0,1-.45-1.06,2.3,2.3,0,0,1,.41-.83,1.91,1.91,0,0,0-1-2.61,5.09,5.09,0,0,0-.71-6.17,1.85,1.85,0,0,1-.67-.93,2,2,0,0,1,.24-1c.81-2.17-.78-4.43-2.28-6.19-1.79-2.1-3.73-4.29-6.36-5.14a11.31,11.31,0,0,1-1.91-.65,8.42,8.42,0,0,1-1.44-1.16,11.62,11.62,0,0,0-11.77-2,8.28,8.28,0,0,1-1.37.49,7,7,0,0,1-1.45.11,16.69,16.69,0,0,0-8.52,2.56A16,16,0,0,1,280,62.83c-.59.23-1.72.18-2.23.57a2.3,2.3,0,0,0-.79,2.71c-3.56,1.63-3.83,4-3.53,7,.12,1.21.81,2.56,2,2.7a3,3,0,0,0,2-.67,13,13,0,0,0,2.42-2.08,5.41,5.41,0,0,1,1.38-1.28,5.69,5.69,0,0,1,1.57-.47,11.24,11.24,0,0,0,6.23-3.85c.31-.39.69-.83,1.19-.79a1.68,1.68,0,0,1,.56.22,7.28,7.28,0,0,0,7.88-.84,10.15,10.15,0,0,0,8.81,7.16c.48,0,1,.08,1.27.49a1.34,1.34,0,0,1,.05,1c-1,5.52-.49,12,.15,17.58.57,5,2.75,8.24,4.77,8.58l3.85-6.76,1.88-3.32A4.15,4.15,0,0,0,319.78,85.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.48,58.77c0-.05-.48-.11-1.16.32a1.4,1.4,0,0,0-.62,1.32,1,1,0,0,0,1.71.68l-.44-.47a3.71,3.71,0,0,0-.78.93,3.46,3.46,0,0,0,.06,3.74c.57.83,1.18,1,1.21,1s-.41-.43-.81-1.21a3.3,3.3,0,0,1,.74-4l-.44-.47a.36.36,0,0,1-.41,0,.45.45,0,0,1-.29-.36,1,1,0,0,1,.33-.91C289.06,59,289.52,58.86,289.48,58.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.44,66.38c0-.06-.34.09-.33.58a1.06,1.06,0,0,0,.33.76.76.76,0,0,0,1.19-.12l-.54-.11a2.07,2.07,0,0,0,1.42,1.86,2.18,2.18,0,0,0,1.13.05l-.39-.3a3.62,3.62,0,0,0,.3,1.4,1.72,1.72,0,0,0,.83.85c.66.29,1.07,0,1-.06s-.39,0-.82-.3a2.2,2.2,0,0,1-.69-1.92v-.38l-.39.08a1.53,1.53,0,0,1-.79,0,1.57,1.57,0,0,1-1-1.28l-.2-1.67-.34,1.57c0,.08-.23.14-.37,0a.77.77,0,0,1-.31-.44C276.35,66.6,276.48,66.42,276.44,66.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.45,93.24c.2-.09,7.85-2.65,7.9,5.25s-7.9,6.33-7.91,6.1S312.45,93.24,312.45,93.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.83,101.58s.14.1.38.2a1.39,1.39,0,0,0,1,0c.84-.32,1.53-1.65,1.56-3.07a4.48,4.48,0,0,0-.4-2,1.57,1.57,0,0,0-1-1.05.71.71,0,0,0-.81.38c-.1.22-.05.38-.09.4s-.17-.14-.11-.46a.87.87,0,0,1,.3-.5,1,1,0,0,1,.76-.21,1.94,1.94,0,0,1,1.45,1.22,4.6,4.6,0,0,1,.49,2.2c0,1.59-.84,3.09-2,3.43a1.52,1.52,0,0,1-1.26-.2C314.85,101.77,314.81,101.6,314.83,101.58Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.48,78.4c.1-.08.65.37,1.24,1.35a9.7,9.7,0,0,1,.53,8.59c-.47,1-1,1.55-1.07,1.49-.28-.14,1-2.57.77-5.79S319.22,78.57,319.48,78.4Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.32,103.4c-.15,0-.34-.77-.95-1.48s-1.34-1-1.29-1.19,1,0,1.69.85S296.46,103.41,296.32,103.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,89c.1.09-.48.85-1.58,1.16s-2,0-1.94-.17.86-.06,1.8-.34S303.93,88.92,304,89Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53,91.54c-.09.12-.73-.19-1.57-.39s-1.55-.24-1.56-.38.75-.36,1.69-.13S304.61,91.43,304.53,91.54Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.06,91.43s.07,0,0,.13-.14.15-.23.17a1.26,1.26,0,0,1-.66-.06c-.46-.14-.76-.4-.71-.53s.44-.1.86,0a5,5,0,0,1,.5.18l.09.07S275,91.42,275.06,91.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,67.08A6.52,6.52,0,0,1,313,68.52a12.37,12.37,0,0,1-12-.65,6.36,6.36,0,0,1-2-1.67c.05-.07.78.59,2.14,1.35a13.51,13.51,0,0,0,5.75,1.68,13.64,13.64,0,0,0,5.91-1C314.25,67.58,315.05,67,315.1,67.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.79,71.48a9.3,9.3,0,0,1-2.34,1.59,9.76,9.76,0,0,1-2.9,1.1,10.47,10.47,0,0,1-3.82,0,16.1,16.1,0,0,1-6.22-2.84,10.37,10.37,0,0,1-2.18-1.8,25.86,25.86,0,0,1,2.38,1.5,18.23,18.23,0,0,0,6.12,2.63,10.37,10.37,0,0,0,3.63.07,10.1,10.1,0,0,0,2.83-1C316.84,72,317.75,71.41,317.79,71.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.66,90.79a4.7,4.7,0,0,0-.49-2,2.92,2.92,0,0,0-1.62-1.35,3.07,3.07,0,0,0-2.57.29l-.4.25v-.47a2.69,2.69,0,0,0-.4-1.4,4.13,4.13,0,0,0-2.63-1.76,7.26,7.26,0,0,0-2.73,0,25.88,25.88,0,0,1-2.54.56,8.49,8.49,0,0,1,2.46-.92,6.94,6.94,0,0,1,2.9-.16,4.52,4.52,0,0,1,3,2,3.18,3.18,0,0,1,.46,1.68l-.39-.22a3.45,3.45,0,0,1,3-.28,3.17,3.17,0,0,1,1.77,1.62A2.46,2.46,0,0,1,335.66,90.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.7,198,268,159.38A58.1,58.1,0,0,0,262.7,198Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.72,200.34a12.29,12.29,0,0,0-7-1c-3.39.37-7.22,1.39-8.85,4,2.41-1.45,6.15-2.47,9.08-1.6s5.35,2.9,7.57,5c.71.68,1.8,1.41,2.57.8a1.78,1.78,0,0,0,.51-1.49A6.94,6.94,0,0,0,357.72,200.34Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Triangle--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.76,250.47h50.78v-87.3Zm20.44-13.4,21.49-36.28v36.28Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.63,242.08a19.89,19.89,0,0,1,5.9,3.66,10.23,10.23,0,0,1-3.11-1.57C397.79,243.16,396.54,242.23,396.63,242.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.08,229.13a9.84,9.84,0,0,1,3,1.56,9.6,9.6,0,0,1,2.7,2.06,18.8,18.8,0,0,1-5.73-3.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53,216.18a9.65,9.65,0,0,1,2.85,1.86c1.46,1.16,2.57,2.21,2.46,2.34a19.06,19.06,0,0,1-5.31-4.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.28,203.46a19.06,19.06,0,0,1,5.31,4.2,9.65,9.65,0,0,1-2.85-1.86C420.28,204.64,419.17,203.59,419.28,203.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.89,190.16a10.56,10.56,0,0,1,3,1.72,10.19,10.19,0,0,1,2.69,2.21,10.38,10.38,0,0,1-3-1.71C428,191.29,426.79,190.3,426.89,190.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.91,176.35a9.12,9.12,0,0,1,2.89,1.54c1.5,1,2.65,1.9,2.55,2a9.12,9.12,0,0,1-2.89-1.54C436,177.41,434.81,176.49,434.91,176.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,238c.09-.14.82.15,1.63.66s1.4,1,1.31,1.16-.82-.14-1.63-.65S398.89,238.19,399,238Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.35,233.8c.09-.14.82.15,1.63.65s1.39,1,1.3,1.17-.81-.15-1.62-.65S401.26,233.94,401.35,233.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.9,224.35c.09-.14.82.15,1.63.66s1.39,1,1.31,1.17-.82-.15-1.63-.66S406.81,224.5,406.9,224.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.27,220.11c.09-.14.82.15,1.63.65s1.39,1,1.3,1.17-.81-.15-1.62-.65S409.18,220.25,409.27,220.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.56,211.57c.09-.14.82.15,1.63.66s1.39,1,1.3,1.17-.81-.15-1.63-.66S414.47,211.72,414.56,211.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.93,207.52c.09-.14.81.15,1.62.66s1.4,1,1.31,1.16-.82-.15-1.63-.65S416.84,207.67,416.93,207.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,198.78c.09-.14.82.15,1.63.66s1.4,1,1.31,1.16-.82-.15-1.63-.65S421.88,198.93,422,198.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.74,194.09c.09-.14.82.15,1.63.65s1.39,1,1.3,1.17-.81-.15-1.62-.65S424.65,194.23,424.74,194.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.68,185.65c.09-.15.82.15,1.63.65s1.4,1,1.31,1.17-.82-.15-1.63-.65S429.6,185.79,429.68,185.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.48,180.77c.09-.14.81.15,1.62.65s1.4,1,1.31,1.17-.82-.15-1.63-.65S432.39,180.91,432.48,180.77Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Globe--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.27,234c0-.44-.09-.88-.15-1.31s-.13-.92-.21-1.38q.12.69.21,1.38C161.18,233.08,161.23,233.52,161.27,234Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,239.42a21,21,0,0,1-.73-2.72,1.78,1.78,0,0,0-.82-1.22,8.33,8.33,0,0,0-1-.22c-1.16-.34-1.48-1.95-2.58-2.45a3.84,3.84,0,0,0-1.11-.22,5.82,5.82,0,0,1-3.92-1.83,8.06,8.06,0,0,0-.91-1.1,1.11,1.11,0,0,0-1.33-.13c.31.62.62,1.23.92,1.84a5,5,0,0,0,1,1.54,1.68,1.68,0,0,0,1.74.36,1.22,1.22,0,0,1,.58-.2.63.63,0,0,1,.38.24,2.53,2.53,0,0,1-.24,3.24,7.5,7.5,0,0,1-3.05,1.79,2.27,2.27,0,0,1-1.24.24c-.77-.14-1.18-1-1.41-1.71-.5-1.65-.74-3.44-1.78-4.83a5.81,5.81,0,0,1-.93-1.35c-.22-.55-.17-1.2-.5-1.68s-1.09-.81-1.14-1.43a1.11,1.11,0,0,1,.73-1c.4-.19.84-.25,1.25-.41.17-.07.35-.19.35-.36s-.36-.36-.45-.6.18-.53.3-.79c.25-.6-.38-1.21-1-1.46s-1.35-.42-1.63-1a3.31,3.31,0,0,1-.2-.88,1.94,1.94,0,0,0-1.46-1.59,1.27,1.27,0,0,0-1.48,1.3,5,5,0,0,0,.55,1.11c.17.38.12.95-.27,1.07-.66.2-1.29-1-1.83-.58l.66,2.28c-.85.43-1.88-.35-2.25-1.24s-.38-1.89-.81-2.73-1.61-1.49-2.36-.89c0,1.09,1.42,1.54,2.07,2.42a1.48,1.48,0,0,1-.29,2.09c-.68.4-1.77-.3-1.51-1,.09-.26.31-.47.33-.75s-.26-.62-.53-.84l-1.25-1a2.65,2.65,0,0,0-.89-.55,2.09,2.09,0,0,0-2.17,1.2,10.59,10.59,0,0,1-1.34,2.28,2.45,2.45,0,0,1-3.45,0,2,2,0,0,1,.83-3.13c.47-.13,1.07-.11,1.32-.53.43-.73-.81-1.66-.38-2.4.33-.57,1.2-.31,1.83-.5s1-.82,1.36-1.36.94-1.08,1.59-.93a1.93,1.93,0,0,1,.07-1.12.69.69,0,0,1,1-.35,1.13,1.13,0,0,0,.62,1.5,3.53,3.53,0,0,0,1.8.13c.61-.08,1.38-.3,1.43-.9,0-.2-.06-.41,0-.59.26-.72,1.61.27,2.12-.31.3-.3,0-.84-.44-.94a4.56,4.56,0,0,0-1.27.07c-.42,0-.93-.21-1-.63s.44-.7.49-1.11c.08-.69-1.1-.87-1.51-.31a2.64,2.64,0,0,0-.15,2,2.1,2.1,0,0,1-.31,2c-.22.33-.79.16-1-.19a2.6,2.6,0,0,1-.18-1.15,1,1,0,0,0-.59-.94,2.36,2.36,0,0,0-.83.09c-1.08.13-1.84-1.25-1.49-2.27a4.31,4.31,0,0,1,2.27-2.21,2.41,2.41,0,0,1,2.25-.35c.32.18.54.48.86.67a3.72,3.72,0,0,0,1.85.21,4.38,4.38,0,0,1,2.71,1c.28.26.54.67.32,1s-.91.38-.79.76a1.35,1.35,0,0,0,1.69-1.08,1.13,1.13,0,0,1,.65.91,2,2,0,0,1,3,.24,2.71,2.71,0,0,0,.55.7c.25.16.69.08.72-.21a.62.62,0,0,0,0-.27c-.15-.42-.31-.83-.46-1.24.58-.31,1.26.17,1.66.68,1.45,1.93,2.49.77,4.54,1.09,1.39.21,2,1.09,2.78,2.15,2.4,3.27,5.57,5.95,7.75,9.37.24.36.45.72.65,1.09l-.11-.27a37.55,37.55,0,0,0-3.17-6.38c-.27-.43-.54-.86-.82-1.28l-.54-.77c-.23-.33-.47-.65-.71-1s-.39-.51-.59-.76l-.42-.52q-.22-.28-.48-.57l-.53-.6-.16-.19-.57-.61s0,0-.06-.06l-.16-.17c-.15-.17-.32-.34-.48-.5s-.54-.54-.82-.8-.47-.44-.71-.66l-.64-.57-.64-.54c-.26-.22-.53-.43-.81-.65h0c-.75-.6-1.53-1.16-2.33-1.69-.2-.14-.39-.27-.59-.39s-.4-.26-.6-.39l-.61-.36-.62-.37c-.16-.1-.33-.19-.49-.27l-.26-.15-1.07-.56c-.18-.09-.36-.19-.55-.27s-.47-.23-.7-.33l-.11-.05-.64-.29-.91-.38c-.35-.15-.7-.29-1.06-.42s-.78-.29-1.18-.41-.8-.27-1.2-.39-.81-.24-1.22-.35q-1.22-.31-2.46-.57h0l-.95-.17-.06,0-.43-.06c-.59-.1-1.19-.18-1.79-.25l-.22,0c-.17,0-.34,0-.52-.06l-1.2-.09c-.42,0-.84,0-1.27-.06l-1.32,0c-1.17,0-2.33.05-3.47.16-.27,0-.54,0-.81.07l-.84.1c-.28,0-.56.07-.83.12l-.84.13-.71.13c-.58.11-1.16.23-1.73.37l-.81.2-.79.22c-.44.12-.87.26-1.3.39h0l-1,.35h0l-1,.39-.06,0-.94.38c-.4.16-.78.33-1.16.51l-1,.44-1,.51,0,0c-.32.16-.63.34-1,.51l-1,.56h0l-.88.54-.33.22-.92.61c-.37.25-.73.52-1.09.78s-.63.47-.93.71A39.36,39.36,0,0,0,92.83,212c-.53.57-1,1.16-1.51,1.77s-.81,1-1.19,1.58-.67.95-1,1.44q.48-.74,1-1.44l.3,0a4.76,4.76,0,0,0,1.65-.27,9.14,9.14,0,0,0,1.22-.93c1.08-.76,2.86-.91,3.15-2.19a9.54,9.54,0,0,1,.14-1.31c.31-.76,1.34-.88,2.18-.86.35,0,.77.05.93.35a.87.87,0,0,1,0,.72,6.71,6.71,0,0,1-2.85,3.47c-1.08.65-2.49,1.15-2.79,2.37.15.41.91.38,1,.81s-.41.53-.57.83.31,1,.82,1a2.27,2.27,0,0,0,1.33-.73,8.37,8.37,0,0,0,2.73-3.64,3.15,3.15,0,0,1,.73-1.73,1.23,1.23,0,0,1,1.85.59c.49-.27,1.25-.48,1.51,0a2.27,2.27,0,0,1,.1.58c.17.78,1.25,1.14,1.37,1.93s-1.06,1.39-2,1.54l-2.52.39a2.36,2.36,0,0,0-1,.33.8.8,0,0,0-.31,1,2.55,2.55,0,0,0,.43.44,1.32,1.32,0,0,1-.85,2.14c-.34,0-.67-.11-1-.12a2.71,2.71,0,0,0-2.25,1.69,6.93,6.93,0,0,1-1.63,2.45c-1.28,1-3.48.73-4.11,2.19a3.56,3.56,0,0,0,0,1.89,2.5,2.5,0,0,1-.23,1.85c-.37.52-1.33.63-1.6.05a1.43,1.43,0,0,1,0-.82c.15-.91.29-1.82.44-2.73a2.69,2.69,0,0,0-.21-2,1.82,1.82,0,0,0-2.57-.08A4.47,4.47,0,0,0,84.12,229a10.66,10.66,0,0,1-.7,2.45h0c-.13.76-.24,1.53-.32,2.31s-.14,1.6-.17,2.41a2.86,2.86,0,0,0,.32-.3c.39-.4,1.18-2.09,1.89-1.26a.62.62,0,0,1,0,.77c-.22.28-.65.34-.82.64s.08.8.42,1a3.71,3.71,0,0,1,1,.72c.45.65,0,1.62.46,2.28s1.19.61,1.88.68l.23,0a3.13,3.13,0,0,1,2.7-2.88c2.58-.57,6,1.54,7.41,3.45,1.61,2.15,2.38,5.19,4.85,6.27,1.78.77,4.29.49,5.16,2.2.77,1.54-.57,3.27-.78,5a17.42,17.42,0,0,0,.33,3.37,2.89,2.89,0,0,1-1.29,2.93c-.58.25-1.31.22-1.77.65-.83.78-.15,2.38-1,3.15a4.37,4.37,0,0,1-1.05.55c-1.86.93-1.81,3.64-.95,5.51,0,.07.07.13.1.2a39,39,0,0,0,8.83,3.86,39.78,39.78,0,0,0,29.76-2.9h0a38,38,0,0,0,3.48-2.07,38.52,38.52,0,0,0,4.88-3.84,36.11,36.11,0,0,0,3-3.08c.66-.75,1.28-1.53,1.88-2.33.31-.41.6-.82.88-1.25a36.39,36.39,0,0,0,2.35-3.88,37.12,37.12,0,0,0,2.54-6.06,38.2,38.2,0,0,0,1.5-6.59c.12-.87.21-1.76.27-2.65a2.25,2.25,0,0,1-1.58.69A2.53,2.53,0,0,1,157.7,239.42Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8,209.12a8.85,8.85,0,0,0-1.8,2c-.6.68-1.67,1.16-2.38.6a1.65,1.65,0,0,1-.54-1.15,3,3,0,0,1,.43-1.78c.34-.54.85-1,1.14-1.55a1.24,1.24,0,0,0-.36-1.68c-.32-.15-.72-.09-1-.29-.51-.37-.14-1.25.45-1.47a4.48,4.48,0,0,1,1.86,0c2.28.15,4-1.33,5.67-2.55,1.33-1,4.17-2.08,5.71-1.11a1.18,1.18,0,0,1,.27,1.83c-.26.19-.61.24-.85.46s-.33.69-.5,1c-.43.91-1.67,1.24-2.07,2.16-.25.56-.14,1.25-.51,1.74A2.2,2.2,0,0,1,117,208l-3,.69A4.66,4.66,0,0,0,112.8,209.12Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.35,257a12.14,12.14,0,0,0-1.44,5.05c-.27,1.74-.74,3.59-2.1,4.74s-3.83,1.08-4.58-.52c-.4-.87-.2-1.9-.42-2.83-.28-1.21-1.26-2.15-1.72-3.31a9,9,0,0,1-.43-3.14c-.18-5.81-1.61-11.87-5.61-16.13a3.88,3.88,0,0,0-1.74-1.21,2.24,2.24,0,0,0-2.3.78,8.33,8.33,0,0,1-.88,1.31c-.85.77-2.34.22-2.91-.78a5.76,5.76,0,0,1-.4-3.35l.36-4.25a3.53,3.53,0,0,1,.63-2.09c.7-.8,2-.84,2.81-1.47,1.12-.83,1.26-2.41,2-3.6s2.92-1.7,3.24-.36c2.34-5,7.5,2.4,10.57,1.85a8.91,8.91,0,0,1,2.66-.46c1.59.22,2.41,1.95,2.95,3.44l2.68,7.42a3.55,3.55,0,0,0,1.73,2.35c.72.28,1.56.07,2.29.33,1.93.7,1.3,3.7-.25,5s-3.73,2.17-4.46,4.06c-.56,1.43-.12,3.1-.71,4.51A17.55,17.55,0,0,1,139.35,257Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.66,258.58c-.63.09-1.38-.22-1.86.19a2,2,0,0,0-.45,1,2.12,2.12,0,0,1-.9,1.21,1.35,1.35,0,0,1-1.46,0,1,1,0,0,1-.21-1.35c.16-.18.38-.29.55-.45.84-.78.27-2.24.9-3.17.38-.55,1-1.11,1.39-1.67s.43-.77,1-.88C148.2,252.93,149.36,258.2,146.66,258.58Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,248a27.16,27.16,0,0,1,.27-3.35c0-.78,0-1.6-.05-2.38a11.07,11.07,0,0,1-2-.27.6.6,0,0,1-.37-.19.79.79,0,0,1-.08-.41c-.05-.87-.9-1.45-1.67-1.89a6.16,6.16,0,0,0-1.21-.59,2.44,2.44,0,0,0,0,.27,38,38,0,0,0,2.5,12.33,36.5,36.5,0,0,0,2.4,5.1c.38.7.81,1.4,1.25,2.08.55.85,1.12,1.67,1.73,2.46s1.18,1.51,1.82,2.22c.88,1,1.81,1.93,2.78,2.83s1.77,1.56,2.71,2.28c-2.15-5.7-4.17-11.51-7.84-16.36C89.31,250.9,88.2,249.6,88,248Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.91,237.11c0,.24,0,.47,0,.7s0,.38,0,.57c0-.19,0-.38,0-.57S82.9,237.35,82.91,237.11Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.31,270.09c.33.22.66.44,1,.65l.72.43-.72-.43C101,270.53,100.64,270.31,100.31,270.09Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.93,236.2h0a1.48,1.48,0,0,0,0,.21c0,.23,0,.47,0,.7,0-.23,0-.47,0-.7A1.48,1.48,0,0,1,82.93,236.2Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9,238.38c0,.19,0,.38,0,.57h0C82.91,238.76,82.91,238.57,82.9,238.38Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,240.8l-.23,0c-.69-.07-1.5-.11-1.88-.68s0-1.63-.46-2.28a3.71,3.71,0,0,0-1-.72c-.34-.24-.63-.68-.42-1s.6-.36.82-.64a.62.62,0,0,0,0-.77c-.71-.83-1.5.86-1.89,1.26a2.86,2.86,0,0,1-.32.3h0a1.48,1.48,0,0,0,0,.21c0,.23,0,.47,0,.7s0,.47,0,.7,0,.38,0,.57,0,.38,0,.57a6.16,6.16,0,0,1,1.21.59c.77.44,1.62,1,1.67,1.89a.79.79,0,0,0,.08.41.6.6,0,0,0,.37.19,11.07,11.07,0,0,0,2,.27",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.24,242.3c0,.78.06,1.6.05,2.38A27.16,27.16,0,0,0,88,248c.18,1.57,1.29,2.87,2.25,4.13,3.67,4.85,5.69,10.66,7.84,16.36h0c.39.31.8.61,1.21.9s.65.45,1,.67.66.44,1,.65l.72.43c0-.07-.07-.13-.1-.2-.86-1.87-.91-4.58.95-5.51a4.37,4.37,0,0,0,1.05-.55c.83-.77.15-2.37,1-3.15.46-.43,1.19-.4,1.77-.65a2.89,2.89,0,0,0,1.29-2.93,17.42,17.42,0,0,1-.33-3.37c.21-1.7,1.55-3.43.78-5-.87-1.71-3.38-1.43-5.16-2.2-2.47-1.08-3.24-4.12-4.85-6.27-1.45-1.91-4.83-4-7.41-3.45a3.13,3.13,0,0,0-2.7,2.88",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.36,226.5a1.82,1.82,0,0,1,2.57.08,2.69,2.69,0,0,1,.21,2c-.15.91-.29,1.82-.44,2.73a1.43,1.43,0,0,0,0,.82c.27.58,1.23.47,1.6-.05a2.5,2.5,0,0,0,.23-1.85,3.56,3.56,0,0,1,0-1.89c.63-1.46,2.83-1.24,4.11-2.19a6.93,6.93,0,0,0,1.63-2.45A2.71,2.71,0,0,1,97.57,222c.34,0,.67.13,1,.12a1.32,1.32,0,0,0,.85-2.14,2.55,2.55,0,0,1-.43-.44.8.8,0,0,1,.31-1,2.36,2.36,0,0,1,1-.33l2.52-.39c.93-.15,2.12-.62,2-1.54s-1.2-1.15-1.37-1.93a2.27,2.27,0,0,0-.1-.58c-.26-.51-1-.3-1.51,0a1.23,1.23,0,0,0-1.85-.59,3.15,3.15,0,0,0-.73,1.73,8.37,8.37,0,0,1-2.73,3.64,2.27,2.27,0,0,1-1.33.73c-.51,0-1-.52-.82-1s.61-.48.57-.83-.82-.4-1-.81c.3-1.22,1.71-1.72,2.79-2.37a6.71,6.71,0,0,0,2.85-3.47.87.87,0,0,0,0-.72c-.16-.3-.58-.35-.93-.35-.84,0-1.87.1-2.18.86a9.54,9.54,0,0,0-.14,1.31c-.29,1.28-2.07,1.43-3.15,2.19a9.14,9.14,0,0,1-1.22.93,4.76,4.76,0,0,1-1.65.27l-.3,0q-.51.71-1,1.44c-.32.48-.62,1-.92,1.48a38.38,38.38,0,0,0-3.4,7.52c-.31.92-.58,1.85-.81,2.8s-.43,1.91-.59,2.89a10.66,10.66,0,0,0,.7-2.45A4.47,4.47,0,0,1,85.36,226.5Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.45,237.28c0-.56,0-1.12,0-1.67,0,.55,0,1.11,0,1.67,0,.18,0,.35,0,.53,0,.86,0,1.71-.08,2.56.05-.85.08-1.7.08-2.56C161.46,237.63,161.46,237.46,161.45,237.28Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,224.24c.18.49.36,1,.52,1.48-.16-.49-.34-1-.52-1.48h0Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.45,237.28c0-.56,0-1.12,0-1.67s-.07-1.1-.13-1.65-.09-.88-.15-1.31-.13-.92-.21-1.38a36.4,36.4,0,0,0-.92-4c-.15-.5-.3-1-.47-1.51s-.34-1-.52-1.48h0c-.2-.37-.41-.73-.65-1.09-2.18-3.42-5.35-6.1-7.75-9.37-.78-1.06-1.39-1.94-2.78-2.15-2-.32-3.09.84-4.54-1.09-.4-.51-1.08-1-1.66-.68.15.41.31.82.46,1.24a.62.62,0,0,1,0,.27c0,.29-.47.37-.72.21a2.71,2.71,0,0,1-.55-.7,2,2,0,0,0-3-.24,1.13,1.13,0,0,0-.65-.91,1.35,1.35,0,0,1-1.69,1.08c-.12-.38.56-.44.79-.76s0-.72-.32-1a4.38,4.38,0,0,0-2.71-1,3.72,3.72,0,0,1-1.85-.21c-.32-.19-.54-.49-.86-.67a2.41,2.41,0,0,0-2.25.35,4.31,4.31,0,0,0-2.27,2.21c-.35,1,.41,2.4,1.49,2.27a2.36,2.36,0,0,1,.83-.09,1,1,0,0,1,.59.94,2.6,2.6,0,0,0,.18,1.15c.18.35.75.52,1,.19a2.1,2.1,0,0,0,.31-2,2.64,2.64,0,0,1,.15-2c.41-.56,1.59-.38,1.51.31,0,.41-.51.7-.49,1.11s.53.64,1,.63a4.56,4.56,0,0,1,1.27-.07c.41.1.74.64.44.94-.51.58-1.86-.41-2.12.31-.08.18,0,.39,0,.59,0,.6-.82.82-1.43.9a3.53,3.53,0,0,1-1.8-.13,1.13,1.13,0,0,1-.62-1.5.69.69,0,0,0-1,.35,1.93,1.93,0,0,0-.07,1.12c-.65-.15-1.22.4-1.59.93s-.73,1.17-1.36,1.36-1.5-.07-1.83.5c-.43.74.81,1.67.38,2.4-.25.42-.85.4-1.32.53a2,2,0,0,0-.83,3.13,2.45,2.45,0,0,0,3.45,0,10.59,10.59,0,0,0,1.34-2.28,2.09,2.09,0,0,1,2.17-1.2,2.65,2.65,0,0,1,.89.55l1.25,1c.27.22.56.5.53.84s-.24.49-.33.75c-.26.75.83,1.45,1.51,1a1.48,1.48,0,0,0,.29-2.09c-.65-.88-2.11-1.33-2.07-2.42.75-.6,1.92,0,2.36.89s.45,1.85.81,2.73,1.4,1.67,2.25,1.24l-.66-2.28c.54-.4,1.17.78,1.83.58.39-.12.44-.69.27-1.07a5,5,0,0,1-.55-1.11,1.27,1.27,0,0,1,1.48-1.3,1.94,1.94,0,0,1,1.46,1.59,3.31,3.31,0,0,0,.2.88c.28.59,1,.77,1.63,1s1.25.86,1,1.46c-.12.26-.4.52-.3.79s.45.34.45.6-.18.29-.35.36c-.41.16-.85.22-1.25.41a1.11,1.11,0,0,0-.73,1c.05.62.79.91,1.14,1.43s.28,1.13.5,1.68a5.81,5.81,0,0,0,.93,1.35c1,1.39,1.28,3.18,1.78,4.83.23.74.64,1.57,1.41,1.71a2.27,2.27,0,0,0,1.24-.24,7.5,7.5,0,0,0,3.05-1.79,2.53,2.53,0,0,0,.24-3.24.63.63,0,0,0-.38-.24,1.22,1.22,0,0,0-.58.2,1.68,1.68,0,0,1-1.74-.36,5,5,0,0,1-1-1.54c-.3-.61-.61-1.22-.92-1.84a1.11,1.11,0,0,1,1.33.13,8.06,8.06,0,0,1,.91,1.1,5.82,5.82,0,0,0,3.92,1.83,3.84,3.84,0,0,1,1.11.22c1.1.5,1.42,2.11,2.58,2.45a8.33,8.33,0,0,1,1,.22,1.78,1.78,0,0,1,.82,1.22,21,21,0,0,0,.73,2.72,2.53,2.53,0,0,0,2.1,1.65,2.25,2.25,0,0,0,1.58-.69h0c.05-.85.08-1.7.08-2.56C161.46,237.63,161.46,237.46,161.45,237.28Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64,253.43c-.59.11-.7.45-1,.88s-1,1.12-1.39,1.67c-.63.93-.06,2.39-.9,3.17-.17.16-.39.27-.55.45A1,1,0,0,0,142,261a1.35,1.35,0,0,0,1.46,0,2.12,2.12,0,0,0,.9-1.21,2,2,0,0,1,.45-1c.48-.41,1.23-.1,1.86-.19C149.36,258.2,148.2,252.93,145.64,253.43Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.27,234c0-.44-.09-.88-.15-1.31s-.13-.92-.21-1.38q.12.69.21,1.38C161.18,233.08,161.23,233.52,161.27,234Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.8,209.12a8.85,8.85,0,0,0-1.8,2c-.6.68-1.67,1.16-2.38.6a1.65,1.65,0,0,1-.54-1.15,3,3,0,0,1,.43-1.78c.34-.54.85-1,1.14-1.55a1.24,1.24,0,0,0-.36-1.68c-.32-.15-.72-.09-1-.29-.51-.37-.14-1.25.45-1.47a4.48,4.48,0,0,1,1.86,0c2.28.15,4-1.33,5.67-2.55,1.33-1,4.17-2.08,5.71-1.11a1.18,1.18,0,0,1,.27,1.83c-.26.19-.61.24-.85.46s-.33.69-.5,1c-.43.91-1.67,1.24-2.07,2.16-.25.56-.14,1.25-.51,1.74A2.2,2.2,0,0,1,117,208l-3,.69A4.66,4.66,0,0,0,112.8,209.12Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.35,257a12.14,12.14,0,0,0-1.44,5.05c-.27,1.74-.74,3.59-2.1,4.74s-3.83,1.08-4.58-.52c-.4-.87-.2-1.9-.42-2.83-.28-1.21-1.26-2.15-1.72-3.31a9,9,0,0,1-.43-3.14c-.18-5.81-1.61-11.87-5.61-16.13a3.88,3.88,0,0,0-1.74-1.21,2.24,2.24,0,0,0-2.3.78,8.33,8.33,0,0,1-.88,1.31c-.85.77-2.34.22-2.91-.78a5.76,5.76,0,0,1-.4-3.35l.36-4.25a3.53,3.53,0,0,1,.63-2.09c.7-.8,2-.84,2.81-1.47,1.12-.83,1.26-2.41,2-3.6s2.92-1.7,3.24-.36c2.34-5,7.5,2.4,10.57,1.85a8.91,8.91,0,0,1,2.66-.46c1.59.22,2.41,1.95,2.95,3.44l2.68,7.42a3.55,3.55,0,0,0,1.73,2.35c.72.28,1.56.07,2.29.33,1.93.7,1.3,3.7-.25,5s-3.73,2.17-4.46,4.06c-.56,1.43-.12,3.1-.71,4.51A17.55,17.55,0,0,1,139.35,257Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.91,237.11c0,.24,0,.47,0,.7s0,.38,0,.57c0-.19,0-.38,0-.57S82.9,237.35,82.91,237.11Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.31,270.09c.33.22.66.44,1,.65l.72.43-.72-.43C101,270.53,100.64,270.31,100.31,270.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.93,236.2h0a1.48,1.48,0,0,0,0,.21c0,.23,0,.47,0,.7,0-.23,0-.47,0-.7A1.48,1.48,0,0,1,82.93,236.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9,238.38c0,.19,0,.38,0,.57h0C82.91,238.76,82.91,238.57,82.9,238.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.64,254.81c.21-1.7,1.55-3.43.78-5-.87-1.71-3.38-1.43-5.16-2.2-2.47-1.08-3.24-4.12-4.85-6.27-1.45-1.91-4.83-4-7.41-3.45a3.13,3.13,0,0,0-2.7,2.88l-.23,0c-.69-.07-1.5-.11-1.88-.68s0-1.63-.46-2.28a3.5,3.5,0,0,0-1-.72c-.34-.24-.63-.68-.42-1s.6-.36.82-.64a.62.62,0,0,0,0-.77c-.71-.83-1.5.86-1.89,1.26a2.86,2.86,0,0,1-.32.3h0a1.48,1.48,0,0,0,0,.21c0,.23,0,.47,0,.7s0,.47,0,.7,0,.38,0,.57,0,.38,0,.57a2.44,2.44,0,0,0,0,.27,38,38,0,0,0,2.5,12.33,36.5,36.5,0,0,0,2.4,5.1c.38.7.81,1.4,1.25,2.08.55.84,1.12,1.67,1.73,2.46s1.18,1.51,1.82,2.22c.88,1,1.81,1.93,2.78,2.83s1.77,1.56,2.71,2.28h0c.39.31.8.61,1.21.9s.65.45,1,.67.66.44,1,.65l.72.43c0-.07-.07-.13-.1-.2-.86-1.87-.91-4.58.95-5.51a4.37,4.37,0,0,0,1.05-.55c.83-.77.15-2.37,1-3.15.46-.43,1.19-.4,1.77-.65a2.89,2.89,0,0,0,1.29-2.93A17.42,17.42,0,0,1,107.64,254.81ZM85.79,241.43a.79.79,0,0,0,.08.41A.79.79,0,0,1,85.79,241.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.36,226.5a1.82,1.82,0,0,1,2.57.08,2.69,2.69,0,0,1,.21,2c-.15.91-.29,1.82-.44,2.73a1.43,1.43,0,0,0,0,.82c.27.58,1.23.47,1.6-.05a2.5,2.5,0,0,0,.23-1.85,3.56,3.56,0,0,1,0-1.89c.63-1.46,2.83-1.24,4.11-2.19a6.93,6.93,0,0,0,1.63-2.45A2.71,2.71,0,0,1,97.57,222c.34,0,.67.13,1,.12a1.32,1.32,0,0,0,.85-2.14,2.55,2.55,0,0,1-.43-.44.8.8,0,0,1,.31-1,2.36,2.36,0,0,1,1-.33l2.52-.39c.93-.15,2.12-.62,2-1.54s-1.2-1.15-1.37-1.93a2.27,2.27,0,0,0-.1-.58c-.26-.51-1-.3-1.51,0a1.23,1.23,0,0,0-1.85-.59,3.15,3.15,0,0,0-.73,1.73,8.37,8.37,0,0,1-2.73,3.64,2.27,2.27,0,0,1-1.33.73c-.51,0-1-.52-.82-1s.61-.48.57-.83-.82-.4-1-.81c.3-1.22,1.71-1.72,2.79-2.37a6.71,6.71,0,0,0,2.85-3.47.87.87,0,0,0,0-.72c-.16-.3-.58-.35-.93-.35-.84,0-1.87.1-2.18.86a9.54,9.54,0,0,0-.14,1.31c-.29,1.28-2.07,1.43-3.15,2.19a9.14,9.14,0,0,1-1.22.93,4.76,4.76,0,0,1-1.65.27l-.3,0q-.51.71-1,1.44c-.32.48-.62,1-.92,1.48a38.38,38.38,0,0,0-3.4,7.52c-.31.92-.58,1.85-.81,2.8s-.43,1.91-.59,2.89a10.66,10.66,0,0,0,.7-2.45A4.47,4.47,0,0,1,85.36,226.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M161.45,237.28c0-.56,0-1.12,0-1.67,0,.55,0,1.11,0,1.67,0,.18,0,.35,0,.53,0,.86,0,1.71-.08,2.56.05-.85.08-1.7.08-2.56C161.46,237.63,161.46,237.46,161.45,237.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159,224.24c.18.49.36,1,.52,1.48-.16-.49-.34-1-.52-1.48h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M161.45,237.28c0-.56,0-1.12,0-1.67s-.07-1.1-.13-1.65-.09-.88-.15-1.31-.13-.92-.21-1.38a36.4,36.4,0,0,0-.92-4c-.15-.5-.3-1-.47-1.51s-.34-1-.52-1.48h0c-.2-.37-.41-.73-.65-1.09-2.18-3.42-5.35-6.1-7.75-9.37-.78-1.06-1.39-1.94-2.78-2.15-2-.32-3.09.84-4.54-1.09-.4-.51-1.08-1-1.66-.68.15.41.31.82.46,1.24a.62.62,0,0,1,0,.27c0,.29-.47.37-.72.21a2.71,2.71,0,0,1-.55-.7,2,2,0,0,0-3-.24,1.13,1.13,0,0,0-.65-.91,1.35,1.35,0,0,1-1.69,1.08c-.12-.38.56-.44.79-.76s0-.72-.32-1a4.38,4.38,0,0,0-2.71-1,3.72,3.72,0,0,1-1.85-.21c-.32-.19-.54-.49-.86-.67a2.41,2.41,0,0,0-2.25.35,4.31,4.31,0,0,0-2.27,2.21c-.35,1,.41,2.4,1.49,2.27a2.36,2.36,0,0,1,.83-.09,1,1,0,0,1,.59.94,2.6,2.6,0,0,0,.18,1.15c.18.35.75.52,1,.19a2.1,2.1,0,0,0,.31-2,2.64,2.64,0,0,1,.15-2c.41-.56,1.59-.38,1.51.31,0,.41-.51.7-.49,1.11s.53.64,1,.63a4.56,4.56,0,0,1,1.27-.07c.41.1.74.64.44.94-.51.58-1.86-.41-2.12.31-.08.18,0,.39,0,.59,0,.6-.82.82-1.43.9a3.53,3.53,0,0,1-1.8-.13,1.13,1.13,0,0,1-.62-1.5.69.69,0,0,0-1,.35,1.93,1.93,0,0,0-.07,1.12c-.65-.15-1.22.4-1.59.93s-.73,1.17-1.36,1.36-1.5-.07-1.83.5c-.43.74.81,1.67.38,2.4-.25.42-.85.4-1.32.53a2,2,0,0,0-.83,3.13,2.45,2.45,0,0,0,3.45,0,10.59,10.59,0,0,0,1.34-2.28,2.09,2.09,0,0,1,2.17-1.2,2.65,2.65,0,0,1,.89.55l1.25,1c.27.22.56.5.53.84s-.24.49-.33.75c-.26.75.83,1.45,1.51,1a1.48,1.48,0,0,0,.29-2.09c-.65-.88-2.11-1.33-2.07-2.42.75-.6,1.92,0,2.36.89s.45,1.85.81,2.73,1.4,1.67,2.25,1.24l-.66-2.28c.54-.4,1.17.78,1.83.58.39-.12.44-.69.27-1.07a5,5,0,0,1-.55-1.11,1.27,1.27,0,0,1,1.48-1.3,1.94,1.94,0,0,1,1.46,1.59,3.31,3.31,0,0,0,.2.88c.28.59,1,.77,1.63,1s1.25.86,1,1.46c-.12.26-.4.52-.3.79s.45.34.45.6-.18.29-.35.36c-.41.16-.85.22-1.25.41a1.11,1.11,0,0,0-.73,1c.05.62.79.91,1.14,1.43s.28,1.13.5,1.68a5.81,5.81,0,0,0,.93,1.35c1,1.39,1.28,3.18,1.78,4.83.23.74.64,1.57,1.41,1.71a2.27,2.27,0,0,0,1.24-.24,7.5,7.5,0,0,0,3.05-1.79,2.53,2.53,0,0,0,.24-3.24.63.63,0,0,0-.38-.24,1.22,1.22,0,0,0-.58.2,1.68,1.68,0,0,1-1.74-.36,5,5,0,0,1-1-1.54c-.3-.61-.61-1.22-.92-1.84a1.11,1.11,0,0,1,1.33.13,8.06,8.06,0,0,1,.91,1.1,5.82,5.82,0,0,0,3.92,1.83,3.84,3.84,0,0,1,1.11.22c1.1.5,1.42,2.11,2.58,2.45a8.33,8.33,0,0,1,1,.22,1.78,1.78,0,0,1,.82,1.22,21,21,0,0,0,.73,2.72,2.53,2.53,0,0,0,2.1,1.65,2.25,2.25,0,0,0,1.58-.69h0c.05-.85.08-1.7.08-2.56C161.46,237.63,161.46,237.46,161.45,237.28Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 119.66,
    y: 279.51,
    width: 5.05,
    height: 17.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18,280.64c-24.19,0-43.86-19.47-43.86-43.4a43.36,43.36,0,0,1,22.59-38l.49-.27,2.93,4.06-1,.74L101,200.66a42.11,42.11,0,0,0-21.45,36.58c0,23.24,19.11,42.14,42.6,42.14a43,43,0,0,0,26.74-9.33l-1.77-1.75.88-.9,2.77,2.74-.54.44A44.18,44.18,0,0,1,122.18,280.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.03,
    y: 297.27,
    width: 38.85,
    height: 3,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.37,476.85c0,.15-97.78.27-218.36.27S31.63,477,31.63,476.85s97.75-.26,218.38-.26S468.37,476.71,468.37,476.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.53,105.45,253,93.91a30.88,30.88,0,1,0-7.4,8.24h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.53,105.45l-14-3.2-.15,0,.09-.12h0l.14.13a31.6,31.6,0,0,1-6.35,3.83,31.19,31.19,0,0,1-8.47,2.42,28.06,28.06,0,0,1-4.89.25c-.84,0-1.7-.07-2.56-.14l-2.61-.4a31.13,31.13,0,0,1-19.3-12.39,30.78,30.78,0,0,1-5.21-11.92,31.47,31.47,0,0,1,.36-13.74,30.44,30.44,0,0,1,6.62-12.7L204.49,56c.41-.46.91-.85,1.36-1.28s.89-.86,1.4-1.22l1.48-1.11a13.94,13.94,0,0,1,1.53-1l1.57-1,1.64-.8a16.44,16.44,0,0,1,1.66-.74A31.52,31.52,0,0,1,229,46.81a30.5,30.5,0,0,1,12.7,3.75,31.33,31.33,0,0,1,14.66,18,33.57,33.57,0,0,1,1.34,10,30.71,30.71,0,0,1-1.51,8.67,31.4,31.4,0,0,1-3.1,6.65v-.1l6.47,11.59L252.9,94l0,0,0,0a31.34,31.34,0,0,0,3-6.62,30.37,30.37,0,0,0,1.47-8.61A33,33,0,0,0,256,68.69,31,31,0,0,0,241.5,50.87a30.16,30.16,0,0,0-12.56-3.7,31.07,31.07,0,0,0-13.67,2.12,14.84,14.84,0,0,0-1.64.72L212,50.8l-1.54.94a12.85,12.85,0,0,0-1.52,1l-1.46,1.1c-.5.35-.92.8-1.39,1.2s-.93.81-1.34,1.27l-1.24,1.37A30,30,0,0,0,197,70.22a31,31,0,0,0-.37,13.57,30.35,30.35,0,0,0,5.14,11.8,30.87,30.87,0,0,0,19.07,12.3l2.58.39c.86.08,1.7.1,2.54.15a26.54,26.54,0,0,0,4.84-.23,30.74,30.74,0,0,0,8.41-2.36,31.33,31.33,0,0,0,6.33-3.77l.57-.44-.44.58h0l0-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,77.73a3.14,3.14,0,1,1-3.14-3.13A3.14,3.14,0,0,1,218,77.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.54,77.73a3.14,3.14,0,1,1-3.14-3.13A3.14,3.14,0,0,1,230.54,77.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.05,76.17A3.13,3.13,0,1,1,238.77,75,3.13,3.13,0,0,1,243.05,76.17Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessor);
export default __webpack_public_path__ + "static/media/Professor.b2c2a8a0669c756d9b40cf021335b9d5.svg";
export { ForwardRef as ReactComponent };